import inputDefaultLight from '../../../common/algorithms/input-default-light';

const condition = (ratio) => ratio >= 1.25;

const light = (params) => inputDefaultLight(params, { condition });

export default light;
